import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { SharedModule } from '../../shared/shared.module';
import { SharedComponentsModule } from '../shared/shared-components.module';
import { CompanyInformationComponent } from './company-information/company-information.component';
import { OverviewComponent } from './overview/overview.component';
import { PaymentMethodComponent } from './payment-method/payment-method.component';
import { AuthnetHostedFormComponent } from './authnet-hosted-form/authnet-hosted-form.component';
import { AccountsComponent } from './accounts/accounts.component';

@NgModule({
  declarations: [
    OverviewComponent,
    CompanyInformationComponent,
    PaymentMethodComponent,
    AuthnetHostedFormComponent,
    AccountsComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    SharedModule,
    SharedComponentsModule
  ]
})
export class PartnerModule { }
